import * as graph from '@adc/sdk'
import {
  utils,
  // @ts-ignore no types
} from '@adc/ui-adc'
import { CombinedListingType } from 'common/context/listing'

export enum RentbackOptionsEnum {
  Yes = 'yes',
  YesDifferent = 'yesDifferent',
  No = 'no',
}

export const questionStepperSteps = [
  {
    stepItem: 'Offer Details',
    completed: false,
    elmId: 'offer_details',
  },
  {
    stepItem: 'Agent Commission',
    completed: false,
    elmId: 'agent_commission',
  },
  {
    stepItem: 'Closing Costs',
    completed: false,
    elmId: 'closing_costs',
  },
  {
    stepItem: 'Contingencies',
    completed: false,
    elmId: 'contingencies',
  },
  {
    stepItem: 'Review and Submit',
    completed: false,
    elmId: 'review_and_submit',
  },
]

export const yesNoOptions = [
  { value: true, text: 'Yes' },
  { value: false, text: 'No' },
]

export const rentbackOptions = [
  { value: RentbackOptionsEnum.Yes, text: 'Yes' },
  {
    value: RentbackOptionsEnum.YesDifferent,
    text: 'Yes, but I want to offer a different amount',
  },
  { value: RentbackOptionsEnum.No, text: 'No' },
]

export const sellerBuyerOptions = [
  {
    value: graph.enums.CommissionPayerType.Seller,
    text: utils.formatters.formatEnum(graph.enums.CommissionPayerType.Seller),
  },
  {
    value: graph.enums.CommissionPayerType.Buyer,
    text: utils.formatters.formatEnum(graph.enums.CommissionPayerType.Buyer),
  },
]

export const acceptedFileTypes = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/bmp',
]

export const TenMbInBytes = 10 * 1048576

export const srpDefaultNearbySearchLinkPath = `/residential/active_lt/auction_date_order,resi_sort_v2_st/y_nbs/100_nsr/bank-owned,newly-foreclosed,,private-seller_at`

// should return a link to the SRP where the county and state match the passed in listing and will either search for bank owned/newly-foreclosed,private-seller_at OR foreclosure_at based on the listing
export const srpDynamicSimilarPropertiesLinkPath = (
  listing: CombinedListingType
) => {
  const firstPartOfDynamicSrpUrl = `/residential/${
    listing.primary_property.summary?.address.country_primary_subdivision || ''
  }/${
    listing.primary_property?.summary?.address.country_secondary_subdivision ||
    ''
  }-county/active_lt/auction_date_order,resi_sort_v2_st/y_nbs`
  if (
    listing.auction?.is_online &&
    listing.listing_configuration?.asset_type ===
      graph.enums.AssetType.Foreclosure
  ) {
    return `${firstPartOfDynamicSrpUrl}/foreclosures_at`
  }
  return `${firstPartOfDynamicSrpUrl}/bank-owned,newly-foreclosed,private-seller_at`
}
